
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/stays",
      function () {
        return require("private-next-pages/account/stays.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/stays"])
      });
    }
  